import { BaseService } from 'hungry-core2'

import actions from '@actions'

export class EditPDFService extends BaseService {
  setPDFData = (pdfData) => {
    this.dispatch(actions.setPDFData(pdfData))
  }

  clearPDFData = () => {
    this.dispatch(actions.clearPDFData())
  }
}
